module.exports = __webpack_public_path__ + "be9a3d1be3c7582d4d9e8730cbc0cfc7.docx"


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader!./src/app/helpers/downloadClipping/foodsafety.docx
 ** module id = 1697
 ** module chunks = 0
 **/